import React, { useState, useEffect, useCallback } from "react";
import { Link } from "react-router-dom";
import AdminService from "../../../api/services/adminService";
import "./Homepage.css";

const METRIC_ROUTES = {
  total_users: "/dashboard/tradelist",
  pending_kyc: "/dashboard/pendingkyc",
  approved_users: "/dashboard/tradelist",
  rejected_users: "/dashboard/pendingkyc",
  today_registration_count: "/dashboard/tradelist",
  total_deposit_24h_usdt: "/dashboard/fundsDManagement",
  total_deposit_30d_usdt: "/dashboard/fundsDManagement",
  deposit_count_24h: "/dashboard/fundsDManagement",
  deposit_count_30d: "/dashboard/fundsDManagement",
  total_withdrawal_24h_usdt: "/dashboard/fundsWithdrawalManagement",
  total_withdrawal_30d_usdt: "/dashboard/fundsWithdrawalManagement",
  withdrawal_count_24h: "/dashboard/fundsWithdrawalManagement",
  withdrawal_count_30d: "/dashboard/fundsWithdrawalManagement",
  spot_volume_24h_usdt: "/dashboard/tradingfeereport",
  spot_volume_30d_usdt: "/dashboard/tradingfeereport",
  futures_volume_24h_usdt: "/dashboard/tradingfeereport",
  futures_volume_30d_usdt: "/dashboard/tradingfeereport",
  total_trading_volume_24h_usdt: "/dashboard/tradingfeereport",
  total_trading_volume_30d_usdt: "/dashboard/tradingfeereport",
  spot_commission_24h_usdt: "/dashboard/tradingfeereport",
  spot_commission_30d_usdt: "/dashboard/tradingfeereport",
  futures_commission_24h_usdt: "/dashboard/tradingfeereport",
  futures_commission_30d_usdt: "/dashboard/tradingfeereport",
  total_trading_commission_24h_usdt: "/dashboard/tradingfeereport",
  total_trading_commission_30d_usdt: "/dashboard/tradingfeereport",
  open_orders_spot: "/dashboard/allOpenOrders",
  open_orders_futures: "/dashboard/allOpenOrders",
  open_orders_total: "/dashboard/allOpenOrders",
  active_pairs_spot: "/dashboard/currencypair",
  active_pairs_futures: "/dashboard/currencypair",
  active_pairs_total: "/dashboard/currencypair",
  staking_packages_total: "/dashboard/staking-packages",
  staking_packages_active: "/dashboard/staking-packages",
  staking_users_count: "/dashboard/staking/user-stakes",
  staking_total_value_usdt: "/dashboard/staking-packages",
};

const formatNumber = (num) => {
  if (num == null || num === "") return "—";
  const n = Number(num);
  if (isNaN(n)) return String(num);
  if (n >= 1e9) return `${(n / 1e9).toFixed(1)}B`;
  if (n >= 1e6) return `${(n / 1e6).toFixed(1)}M`;
  if (n >= 1e3) return `${(n / 1e3).toFixed(1)}K`;
  return n.toLocaleString("en-IN", { maximumFractionDigits: 2 });
};

const METRIC_SECTIONS = [
  {
    title: "Users & KYC",
    cards: [
      { key: "total_users", label: "Total Users", icon: "fa-users", color: "#0d9488" },
      { key: "pending_kyc", label: "Pending KYC", icon: "fa-id-card", color: "#dc2626" },
      { key: "approved_users", label: "Approved Users", icon: "fa-user-check", color: "#16a34a" },
      { key: "rejected_users", label: "Rejected Users", icon: "fa-user-xmark", color: "#b91c1c" },
      { key: "today_registration_count", label: "Today Registrations", icon: "fa-user-plus", color: "#6366f1" },
    ],
  },
  {
    title: "Deposits",
    cards: [
      { key: "total_deposit_24h_usdt", label: "Deposit (24h)", icon: "fa-arrow-down", color: "#16a34a" },
      { key: "total_deposit_30d_usdt", label: "Deposit (30d)", icon: "fa-arrow-down", color: "#15803d" },
      { key: "deposit_count_24h", label: "Deposits Count (24h)", icon: "fa-hashtag", color: "#166534" },
      { key: "deposit_count_30d", label: "Deposits Count (30d)", icon: "fa-hashtag", color: "#14532d" },
    ],
  },
  {
    title: "Withdrawals",
    cards: [
      { key: "total_withdrawal_24h_usdt", label: "Withdrawal (24h)", icon: "fa-arrow-up", color: "#0d9488" },
      { key: "total_withdrawal_30d_usdt", label: "Withdrawal (30d)", icon: "fa-arrow-up", color: "#0f766e" },
      { key: "withdrawal_count_24h", label: "Withdrawals Count (24h)", icon: "fa-hashtag", color: "#134e4a" },
      { key: "withdrawal_count_30d", label: "Withdrawals Count (30d)", icon: "fa-hashtag", color: "#115e59" },
    ],
  },
  {
    title: "Trading Volume",
    cards: [
      { key: "spot_volume_24h_usdt", label: "Spot Volume (24h)", icon: "fa-chart-line", color: "#ea580c" },
      { key: "spot_volume_30d_usdt", label: "Spot Volume (30d)", icon: "fa-chart-line", color: "#c2410c" },
      { key: "futures_volume_24h_usdt", label: "Futures Volume (24h)", icon: "fa-chart-area", color: "#7c3aed" },
      { key: "futures_volume_30d_usdt", label: "Futures Volume (30d)", icon: "fa-chart-area", color: "#6d28d9" },
      { key: "total_trading_volume_24h_usdt", label: "Total Volume (24h)", icon: "fa-coins", color: "#dc2626" },
      { key: "total_trading_volume_30d_usdt", label: "Total Volume (30d)", icon: "fa-coins", color: "#b91c1c" },
    ],
  },
  {
    title: "Trading Commission",
    cards: [
      { key: "spot_commission_24h_usdt", label: "Spot Fee (24h)", icon: "fa-percent", color: "#7c3aed" },
      { key: "spot_commission_30d_usdt", label: "Spot Fee (30d)", icon: "fa-percent", color: "#6d28d9" },
      { key: "futures_commission_24h_usdt", label: "Futures Fee (24h)", icon: "fa-percent", color: "#6366f1" },
      { key: "futures_commission_30d_usdt", label: "Futures Fee (30d)", icon: "fa-percent", color: "#4f46e5" },
      { key: "total_trading_commission_24h_usdt", label: "Total Fee (24h)", icon: "fa-percent", color: "#0f766e" },
      { key: "total_trading_commission_30d_usdt", label: "Total Fee (30d)", icon: "fa-percent", color: "#0d9488" },
    ],
  },
  {
    title: "Open Orders",
    cards: [
      { key: "open_orders_spot", label: "Open Orders (Spot)", icon: "fa-list", color: "#16a34a" },
      { key: "open_orders_futures", label: "Open Orders (Futures)", icon: "fa-list", color: "#15803d" },
      { key: "open_orders_total", label: "Open Orders (Total)", icon: "fa-list-ul", color: "#166534" },
    ],
  },
  {
    title: "Active Pairs",
    cards: [
      { key: "active_pairs_spot", label: "Active Pairs (Spot)", icon: "fa-exchange-alt", color: "#6366f1" },
      { key: "active_pairs_futures", label: "Active Pairs (Futures)", icon: "fa-exchange-alt", color: "#4f46e5" },
      { key: "active_pairs_total", label: "Active Pairs (Total)", icon: "fa-chart-line", color: "#0d9488" },
    ],
  },
  {
    title: "Staking",
    cards: [
      { key: "staking_packages_total", label: "Total Packages", icon: "fa-coins", color: "#7c3aed" },
      { key: "staking_packages_active", label: "Active Packages", icon: "fa-layer-group", color: "#6d28d9" },
      { key: "staking_users_count", label: "Staking Users", icon: "fa-users", color: "#5b21b6" },
      { key: "staking_total_value_usdt", label: "Total Staked", icon: "fa-wallet", color: "#4f46e5" },
    ],
  },
];

const formatDateTime = (iso) => {
  try {
    const d = new Date(iso);
    return d.toLocaleString("en-IN", {
      day: "numeric",
      month: "numeric",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  } catch {
    return iso || "N/A";
  }
};

const getGreeting = () => {
  const hour = new Date().getHours();
  if (hour < 12) return "Good morning";
  if (hour < 17) return "Good afternoon";
  return "Good evening";
};

const getFormattedDate = () => {
  return new Date().toLocaleDateString("en-IN", {
    weekday: "long",
    day: "numeric",
    month: "long",
    year: "numeric",
  });
};

const Homepage = () => {
  const [counts, setCounts] = useState(null);
  const [countsLoading, setCountsLoading] = useState(true);
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const fetchCounts = useCallback(async () => {
    setCountsLoading(true);
    const res = await AdminService.getDashboardCounts();
    setCountsLoading(false);
    if (res?.success) {
      setCounts(res.data || {});
    } else {
      setCounts({});
    }
  }, []);

  const fetchLogs = useCallback(async () => {
    setLoading(true);
    setError("");
    const res = await AdminService.getAdminLogs({ page: 1, limit: 20 });
    setLoading(false);
    if (res?.success) {
      setLogs(res.data || []);
    } else {
      setError(res?.message || "Failed to load activity logs.");
      setLogs([]);
    }
  }, []);

  useEffect(() => {
    fetchCounts();
  }, [fetchCounts]);

  useEffect(() => {
    fetchLogs();
  }, [fetchLogs]);

  return (
    <main className="dashboard-main dashboard-home">
      <section className="dashboard-hero home-hero">
        <div className="dashboard-hero__text">
          <div className="home-hero__meta">
            <p className="dashboard-hero__greeting">{getGreeting()}</p>
            <span className="home-hero__date">{getFormattedDate()}</span>
          </div>
          <h1 className="dashboard-hero__title">Dashboard</h1>
          <p className="dashboard-hero__subtitle">
            Overview of your exchange metrics and recent activity
          </p>
        </div>
        <div className="home-hero__icons">
          <div className="dashboard-hero__icon home-hero__icon--chart">
            <i className="fas fa-chart-line" />
          </div>
          <div className="home-hero__stats-pill">
            <i className="fas fa-signal" />
            <span>Live</span>
          </div>
        </div>
      </section>

      <div className="dashboard-body">
        {METRIC_SECTIONS.map((section) => (
          <div key={section.title} className="home-metrics-section">
            <h3 className="home-metrics-section__title">{section.title}</h3>
            <div className="dashboard-metrics home-metrics">
              {section.cards.map((card) => {
                const val = counts?.[card.key];
                const display = val != null ? formatNumber(val) : countsLoading ? "…" : "—";
                const isUsdt = card.key.includes("_usdt");
                const to = METRIC_ROUTES[card.key];
                const CardWrapper = to ? Link : "div";
                const cardProps = to ? { to } : {};
                return (
                  <CardWrapper
                    key={card.key}
                    className={`dashboard-card home-card ${to ? "home-card--link" : ""}`}
                    {...cardProps}
                  >
                    <div className="home-card__accent" style={{ background: card.color }} />
                    <div className="dashboard-card__label">{card.label}</div>
                    <div className="dashboard-card__value">
                      {display}
                      {isUsdt && display !== "…" && display !== "—" && (
                        <span className="home-card__currency"> USDT</span>
                      )}
                    </div>
                    <div
                      className="dashboard-card__icon home-card__icon"
                      style={{ background: card.color }}
                    >
                      <i className={`fas ${card.icon}`} />
                    </div>
                  </CardWrapper>
                );
              })}
            </div>
          </div>
        ))}

        <section className="dashboard-activity-section home-activity">
          <div className="dashboard-activity-header home-activity-header">
            <div className="home-activity-header__left">
              <div className="dashboard-activity-header__icon">
                <i className="fas fa-clock-rotate-left" />
              </div>
              <div>
                <h2 className="dashboard-activity-header__title">Login & Activity</h2>
                <p className="home-activity-header__subtitle">Recent admin login history</p>
              </div>
            </div>
            <div className="home-activity-actions">
              {sessionStorage.getItem("userType") === "1" && (
                <Link to="/dashboard/admin-logs" className="home-activity-view-all">
                  View all logs
                </Link>
              )}
              <button
                type="button"
                className="home-activity-refresh"
                title="Refresh"
                onClick={fetchLogs}
                disabled={loading}
              >
                <i className={`fas fa-arrows-rotate ${loading ? "fa-spin" : ""}`} />
                <span>{loading ? "Loading…" : "Refresh"}</span>
              </button>
            </div>
          </div>
          <div className="dashboard-activity-table-wrap">
            {error && (
              <div className="home-activity-error">
                <i className="fas fa-exclamation-circle" /> {error}
              </div>
            )}
            <table className="dashboard-activity-table home-activity-table">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Activity</th>
                  <th>IP Address</th>
                  <th>Date & Time</th>
                </tr>
              </thead>
              <tbody>
                {loading && logs.length === 0 ? (
                  <tr>
                    <td colSpan={4} className="home-activity-loading">
                      <i className="fas fa-spinner fa-spin" /> Loading activity logs…
                    </td>
                  </tr>
                ) : logs.length === 0 ? (
                  <tr>
                    <td colSpan={4} className="home-activity-empty">
                      No recent admin activity.
                    </td>
                  </tr>
                ) : (
                  logs.map((row, idx) => (
                    <tr key={row._id || idx}>
                      <td className="home-activity-sr">{idx + 1}</td>
                      <td>
                        <span className="activity-cell home-activity-cell">
                          <span className="activity-cell__dot" />
                          <i className="fas fa-user-shield activity-cell__icon" />
                          {row.action || row.route || "—"}
                        </span>
                      </td>
                      <td><code className="home-activity-ip">{row.ip || "—"}</code></td>
                      <td className="home-activity-datetime">{formatDateTime(row.createdAt)}</td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </section>
      </div>
    </main>
  );
};

export default Homepage;
